import { FormDialog } from 'components/dialog/form'
import { PostEvaluationResult, usePostEvaluationResultList } from 'interface/search/evaluation'
import { EvaluationUploadForm, useEvaluationUploadForm } from '../form/evaluationUploadForm'
import { SearchResult } from 'interface/search'

type EvaluationUploadDialogProps = {
  search: SearchResult
  onSubmit: (result: PostEvaluationResult) => void
  onClose: () => void
}
export const EvaluationUploadDialog = ({
  search,
  onSubmit,
  onClose
}: EvaluationUploadDialogProps) => {
  const form = useEvaluationUploadForm(search)
  const [postState, post] = usePostEvaluationResultList(
    search.searchId, { onPosted: onSubmit }
  )
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="評価データアップロード"
      isLoading={form.loading || postState.posting}
      error={postState.error}
      body={
        <EvaluationUploadForm
          {...form}
        />
      }
      submitLabel="実 行"
      isValid={!form.isDisabled}
      onSubmit={(e) => {
        e.preventDefault()
        form.submit((postData) => {
          post(postData)
        })
      }}
      onClose={onClose}
    />
  )
}
